// extracted by mini-css-extract-plugin
module.exports = {"large":"only screen and (min-width: 993px)","medium":"only screen and (min-width: 768px)","container":"container-3U_G-","bold":"bold-25f0Z"};